<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="520" scrollable>
    <v-card class="rounded-xl">
      <v-card-title class="subtitle-1 font-weight-bold">
        <v-icon left color="primary">mdi-sort</v-icon>
        {{ nodo && nodo.id == null ? "Ordenar armarios principales" : `Ordenar hijos de ${nodo?.name}` }}
      </v-card-title>
      <v-card-subtitle class="pt-1">Arrastra los elementos o usa las flechas</v-card-subtitle>

      <v-card-text class="px-3" style="max-height: 60vh">
        <div
          v-for="(hijo, i) in lista"
          :key="hijo.id"
          class="fila-orden d-flex align-center"
          :class="{ 'fila-arrastrando': arrastrando === i, 'fila-destino': destino === i && arrastrando !== i }"
          draggable="true"
          @dragstart="iniciarArrastre(i, $event)"
          @dragover.prevent="destino = i"
          @dragleave="destino = destino === i ? null : destino"
          @drop.prevent="soltar(i)"
          @dragend="arrastrando = destino = null"
        >
          <v-icon small class="asa mr-2">mdi-drag-vertical</v-icon>
          <span class="posicion mr-3">{{ i + 1 }}</span>
          <span class="nombre">{{ hijo.name }}</span>
          <v-btn icon x-small class="flecha" :disabled="i === 0" :aria-label="`Subir ${hijo.name}`" @click="mover(i, i - 1)">
            <v-icon small>mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn icon x-small class="flecha" :disabled="i === lista.length - 1" :aria-label="`Bajar ${hijo.name}`" @click="mover(i, i + 1)">
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn text small class="text-none" @click="ordenarAlfabeticamente">
          <v-icon left small>mdi-sort-alphabetical-ascending</v-icon> A-Z
        </v-btn>
        <v-spacer />
        <v-btn text @click="$emit('update:dialog', false)">Cancelar</v-btn>
        <v-btn color="primary" depressed :disabled="!cambiado" :loading="guardando" @click="guardar">Guardar orden</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogOrdenarHijos",
  props: {
    dialog: { type: Boolean, default: false },
    nodo: { type: Object, default: null },
    guardando: { type: Boolean, default: false },
  },
  data() {
    return { lista: [], arrastrando: null, destino: null };
  },
  computed: {
    cambiado() {
      const original = (this.nodo?.children || []).map((h) => h.id).join(",");
      return this.lista.map((h) => h.id).join(",") !== original;
    },
  },
  watch: {
    // copia de los hijos cada vez que se abre: si se cancela, el árbol no cambia
    dialog: {
      immediate: true,
      handler(abierto) {
        if (abierto) this.lista = [...(this.nodo?.children || [])];
      },
    },
  },
  methods: {
    mover(desde, hasta) {
      if (hasta < 0 || hasta >= this.lista.length || desde === hasta) return;
      const lista = [...this.lista];
      const [elemento] = lista.splice(desde, 1);
      lista.splice(hasta, 0, elemento);
      this.lista = lista;
    },
    iniciarArrastre(i, evento) {
      this.arrastrando = i;
      evento.dataTransfer.effectAllowed = "move";
      evento.dataTransfer.setData("text/plain", String(i)); // necesario en Firefox
    },
    soltar(i) {
      if (this.arrastrando !== null) this.mover(this.arrastrando, i);
      this.arrastrando = this.destino = null;
    },
    ordenarAlfabeticamente() {
      this.lista = [...this.lista].sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", "es", { numeric: true, sensitivity: "base" })
      );
    },
    guardar() {
      this.$emit("guardar", { nodo: this.nodo, ids: this.lista.map((h) => h.id) });
    },
  },
};
</script>

<style scoped>
.fila-orden {
  padding: 6px 8px;
  margin-bottom: 4px;
  border: 1px solid #e0e4e9;
  border-radius: 8px;
  background: white;
  cursor: grab;
  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}
.fila-orden:hover {
  border-color: #b9cbd4;
}
.fila-arrastrando {
  opacity: 0.45;
}
.fila-destino {
  border-color: #117f9c;
  background: rgba(17, 127, 156, 0.06);
}
.asa,
.posicion,
.flecha {
  flex-shrink: 0;
}
.asa {
  color: #90a4ae;
}
.posicion {
  min-width: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #117f9c;
  text-align: right;
}
/* nombre completo: si es largo ocupa varias líneas */
.nombre {
  flex: 1 1 auto;
  min-width: 0;
  margin-right: 4px;
  font-weight: 500;
  color: #37474f;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
</style>
